import React, { useContext } from 'react';

import { NowPlayingContext } from '../../contexts/now-playing.context';

import { TiMediaPause, TiMediaPlay } from 'react-icons/ti';
import { Button } from './PlayButton.styles';

const PlayButton = ({
  episode,
  author,
  className,
  authorId,
  isLoaded,
  isPlaying
}) => {
  const { setEpisode, setPlaying } = useContext(NowPlayingContext);
  const handleClick = () => {
    if (isPlaying && isLoaded) {
      return setPlaying(!isPlaying);
    }
    setEpisode({ ...episode, author, authorId });
  };
  return (
    <Button className={`play-now, ${className}`} onClick={handleClick}>
      {isLoaded && isPlaying ? <TiMediaPause /> : <TiMediaPlay />}
    </Button>
  );
};

export default PlayButton;
